import { jsx as _jsx } from "react/jsx-runtime";
import { PersonalPage } from './profile.js';
import { SecurityPage } from './security.js';
/** One page of the profile; `link` leads to a tab of the security by its slug. */
export function ProfileArea({ me, area, tab, link, go, }) {
    return area === 'personal' ? (_jsx(PersonalPage, { me: me })) : (_jsx(SecurityPage, { me: me, tab: tab, link: link, go: go }));
}
//# sourceMappingURL=profile-areas.js.map